import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services';
import { checkTranslation, imageAddress, translate } from '../../utils/useful';
import { Loader } from 'react-loader-spinner';
import Responsive from '../../components/Responsive';

export default class DriveSelectApplet extends Component {

    state = {
        list: [],
        currentApplet: '',
        currentAppletName: '',
        template: [
            // { image: '/assets/icons/applets/drive/drive-folder.svg', title: '{{lang}}New Folder', des: '' },
            // { image: '/assets/icons/note/addnoteimg.svg', title: '{{lang}}New Upload', des: '' },
            // { image: '/assets/icons/note/addnoteimg.svg', title: '{{lang}}New Note', des: '' },
            { image: '/assets/icons/note/n1.png', title: '{{lang}}Resume', des: '{{lang}}Coral' },
            { image: '/assets/icons/note/n2.png', title: '{{lang}}Resume', des: '{{lang}}Serif' },
            { image: '/assets/icons/note/n3.png', title: '{{lang}}Letter', des: '{{lang}}Spearmint' },
            { image: '/assets/icons/note/n4.png', title: '{{lang}}Project proposal', des: '{{lang}}Tropic' },
            { image: '/assets/icons/note/n5.png', title: '{{lang}}Brochure', des: '{{lang}}Geometric' },
            { image: '/assets/icons/note/n6.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n1.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n2.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n3.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n4.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n5.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n6.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
        ],
        isLoadingList: false
    }

    componentDidMount() {
        // this.fetchList()
        if (this.props.setHeader) {
            // console.log("SET HEADER")
            this.props.setHeader({
                showToolbar: false,
                showSettings: false,
                showSettings: false,
                showFrames: false,
                isPortal: this.props.isPortal,
                title: '{{lang}}Drive',
                type: 'drive',
            })
        }
    }

    fetchList = () => {
        let data = {}
        data.features = this.props.type
        // this.setState({ isLoadingList: true })
        let list = this.state.list
        HttpServices.request('getMyAppletsType', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            fetchResult.info.map((element, index) => {
                if (element.applet.default) {
                    element.applet.name = element.appletHub.fullname
                }
            })
            list = fetchResult.info
            this.setState({ list, }, () => {
                this.setState({ isLoadingList: false })
            })
        })
    }

    changeHub = (prop) => {
        // console.log('prop', prop)
        // let currentApplet = this.state.currentApplet
        // // let currentAppletName = this.state.currentAppletName
        // if (!prop?.applet) {
        //     currentApplet = ''
        //     // currentAppletName = prop.name
        // }
        // else {
        //     currentApplet = prop.applet._id
        //     // currentAppletName = prop.applet.name
        // }
        // this.setState({ currentApplet, currentAppletName }, () => {
        // this.props.setCurrentApplet('currentApplet', currentApplet)
        // this.props.setCurrentApplet('currentAppletName', currentAppletName)
        // this.props.changeBaseUrl(currentApplet)
        // console.log('this.state.currentApplet', this.state.currentApplet)
        this.props.changePage(['hub', prop.username], null, true)
        // this.props.setCurrentApplet('showDirectory', true)
        // return currentApplet
        // })
    }


    changeApplet = (prop) => {
        let currentApplet = ['applet', prop._id]
        // console.log('prop', prop)
        // let currentApplet = this.state.currentApplet
        // // let currentAppletName = this.state.currentAppletName
        // if (!prop?.applet) {
        //     currentApplet = ''
        //     // currentAppletName = prop.name
        // }
        // else {
        //     currentApplet = prop.applet._id
        //     // currentAppletName = prop.applet.name
        // }
        // this.setState({ currentApplet, currentAppletName }, () => {
        // this.props.setCurrentApplet('currentApplet', currentApplet)
        // this.props.setCurrentApplet('currentAppletName', currentAppletName)
        // this.props.changeBaseUrl(currentApplet)
        // console.log('this.state.currentApplet', this.state.currentApplet)
        this.props.changePage(currentApplet, null, true)
        // this.props.setCurrentApplet('showDirectory', true)
        // return currentApplet
        // })
    }

    changeFrame = (prop) => {

        let path = ['frame', prop._id]

        this.props.changePage(path, null, true)


    }

    openSelectAppletModal = (data, func) => {
        if (this.props.currentApplet == '') {
            if (this.props.openSelectAppletModal) {
                this.props.openSelectAppletModal()
            }
            this.props.setData(data, true, 'FileManager')
        }
        else {
            this.props.functionsHandler(null, func)
        }
    }

    render() {

        let hubs = this.props.hubs ?? []
        let applets = this.props.applets ? this.props.applets.filter((a) => (a.hub?._id ?? a.hub) == this.props.currentHub?._id) : []

        // console.log(applets)

        let frames = this.props.frames ? this.props.frames.filter((a) => (a.applet?._id ?? a.applet) == this.props.currentApplet?._id) : []

        return (
            <div className='scroll-no-scrollbar w-100 h-100 pb-5'>
                <div style={{ backgroundColor: '#F7F4EF' }}>
                    {/* <div className='px-4 py-3 flexcb w-100' >
                        <p className='font-size-14 weight-500 main-c4' style={{ cursor: 'default' }}>{translate('Recently used')}</p>
                        <div className='flexc '>
                            <button className='flexcb w-100 dark-blur-hover px-2 py-1 br-5 mx-4'>
                                <p className='main-c6 pld-2'>{translate('notebook.Yonnect Template')}</p>
                                <img className='flexcc mld-4' width={24} src='/assets/icons/arrow-ud-gray.svg' />
                            </button>
                            <button className='dark-blur-hover p-1 br-5'>
                                <img className='flexcc' width={24} src='/assets/icons/more-gray.svg' />
                            </button>
                        </div>
                    </div> */}
                    <div className='w-100 flexcb px-3 pb-3 sc-note-b pt-4' style={{ overflowX: 'auto' }}>
                        <button className='text-left px-2' onClick={() => { this.openSelectAppletModal('newFolder', 'folderModal') }}>
                            <div className='bg-white note-hover br-5 flexcc' style={{ width: 100, height: 100 }}>
                                <img className='' width={50} src={'/assets/icons/applets/drive/drive-folder.svg'} />
                            </div>
                            <p className='font-size-12 weight-500 main-c4 pt-2'>{translate('New Folder')}</p>
                            {/* <p className='font-size-10 weight-300 main-c7'>{checkTranslation(prop.des)}</p> */}
                        </button>
                        <button className='text-left px-2' onClick={() => { this.openSelectAppletModal('newUpload', 'uploadModal') }}>
                            <div className='bg-white note-hover br-5 flexcc' style={{ width: 100, height: 100 }}>
                                <div style={{ position: 'relative' }}>
                                    <img className="" style={{}} src={'/assets/icons/applets/drive/drive-folder.svg'} draggable={false} width={50} />
                                    <div className="flexcc" style={{ position: 'absolute', top: 35, left: 35, backgroundColor: 'rgb(255 246 233)', borderRadius: '100px' }}>
                                        <img className="m-1 flexcc" src={'/assets/icons/applets/drive/arrow.up.orange.svg'} width={20} draggable={false} />
                                    </div>
                                </div>
                            </div>
                            <p className='font-size-12 weight-500 main-c4 pt-2'>{translate('New Upload')}</p>
                            {/* <p className='font-size-10 weight-300 main-c7'>{checkTranslation(prop.des)}</p> */}
                        </button>
                        <button className='text-left px-2' onClick={() => { this.openSelectAppletModal('newNote', 'openNote') }}>
                            <div className='bg-white note-hover br-5 flexcc' style={{ width: 100, height: 100 }}>
                                <img className="" style={{}} src={'/assets/icons/applets/drive/plus.svg'} draggable={false} width={50} />
                            </div>
                            <p className='font-size-12 weight-500 main-c4 pt-2'>{translate('New Note')}</p>
                            {/* <p className='font-size-10 weight-300 main-c7'>{checkTranslation(prop.des)}</p> */}
                        </button>
                        {this.state.template.map((prop, index) => {
                            return (
                                <button className='text-left px-2' >
                                    <div className='bg-white note-hover br-5 flexcc' style={{ width: 100, height: 100 }}>
                                        <img className='br-5' width={100} height={100} src={prop.image} />
                                    </div>
                                    <p className='font-size-12 weight-500 main-c4 pt-2'>{checkTranslation(prop.title)}</p>
                                    {/* <p className='font-size-10 weight-300 main-c7'>{checkTranslation(prop.des)}</p> */}
                                </button>
                            )
                        })}
                    </div>
                </div>
                <div className='py-1 px-3 sc-gray2' style={{}}>
                    {this.state.isLoadingList ?
                        (
                            <Loader
                                type="Oval"
                                color="#789"
                                height={50}
                                width={50}
                            />
                        ) :
                        (
                            <div className=' pt-3'>

                                {!this.props.currentHub && (<>
                                    <div className='px-1'>
                                        <p className='font-size-15 weight-600' >{translate('Available hubs')}</p>
                                    </div>


                                    <div className='d-flex flex-wrap pt-3'>

                                        {Array.isArray(hubs) && hubs.length > 0 && (
                                            hubs?.map((prop, index) => {
                                                // let name = prop?.applet?.name ? prop?.applet?.name : prop?.name
                                                return (

                                                    <Responsive className={'px-1 mb-1'} key={index} width={this.props.width} media={{ xs: "12", sm: '6', md: '4', lg: "3", xl: "3" }}>

                                                        <button className='flexc py-2 w-100 bb-gray br-10 px-2' onClick={() => this.changeHub(prop)} style={{ backgroundColor: "#fff", boxShadow: '0px 0px 10px #10101010' }}>
                                                            {/* {prop.applet.image ?
                                                <div className='mrd-4'>
                                                    <img className='br-50' width={30} height={30} src={imageAddress(prop.applet?.image, "applet")} />
                                                </div>
                                                : */}
                                                            <div className='mrd-4 flexcc' style={{ position: 'relative', }} >
                                                                <img className="br-50" style={{ width: 60, height: 60, objectFit: 'cover', border: '2px solid #ffffff90' }} src={imageAddress(prop?.image, 'profile', 'thumb')} />
                                                                {/* <div className='flexcc' style={{ position: 'absolute', bottom: -6, right: -6, backgroundColor: '#ffffffcc', borderRadius: 20, height: 24, width: 24 }}>
                                                        <img src={'/assets/icons/applets/' + ((prop?.features && prop?.features[0]) ? String(prop?.features[0]).toLowerCase() : String(prop.applet?.type).toLowerCase()) + ".png"} width="22px" style={{ height: 22, borderRadius: 100, objectFit: 'cover', border: '2px solid #ffffff90' }} />
                                                    </div> */}
                                                            </div>
                                                            {/* } */}

                                                            <div className='d-flex flex-column' style={{ textAlign: 'start' }}>
                                                                <p className='font-size-14 main-c2 text-bold'>{prop?.fullname}</p>
                                                                <p className='font-size-12 main-c9'>@{prop?.username}</p>

                                                            </div>
                                                        </button>
                                                    </Responsive>
                                                )

                                            })
                                        )}
                                    </div>
                                </>)}


                                {this.props.currentHub && !this.props.currentApplet && (<>

                                    <div className='px-1'>
                                        <p className='font-size-15 weight-600' >{translate('Available applets')}</p>
                                    </div>
                                    <div className='d-flex flex-wrap pt-3'>

                                        {Array.isArray(applets) && applets.length > 0 && (
                                            applets?.map((prop, index) => {
                                                // let name = prop?.applet?.name ? prop?.applet?.name : prop.name
                                                return (

                                                    <Responsive className={'px-1 mb-1'} key={index} width={this.props.width} media={{ xs: "12", sm: '6', md: '4', lg: "3", xl: "3" }}>

                                                        <button className='flexc py-2 w-100 bb-gray br-10 px-2' onClick={() => this.changeApplet(prop)} style={{ backgroundColor: "#fff", boxShadow: '0px 0px 10px #10101010' }}>

                                                            <div className='mrd-4 flexcc' style={{ position: 'relative', }} >
                                                                <img className="br-50" style={{ width: 60, height: 60, objectFit: 'cover', border: '2px solid #ffffff90' }} src={imageAddress(prop?.image, 'applet', 'thumb')} alt='' />
                                                            </div>

                                                            <div className='d-flex flex-column' style={{ textAlign: 'start' }}>
                                                                <p className='font-size-14 main-c2 text-bold'>{checkTranslation(prop?.name)}</p>
                                                                {prop.hub &&
                                                                    <p className='font-size-12 main-c9'>{checkTranslation(prop.hub?.fullname)}</p>
                                                                }
                                                            </div>
                                                        </button>
                                                    </Responsive>
                                                )

                                            })
                                        )}
                                    </div>
                                </>)}


                                {this.props.currentHub && this.props.currentApplet && !this.props.currentFrame && (<>

                                    <div className='px-1'>
                                        <p className='font-size-15 weight-600' >{translate('Available frames')}</p>
                                    </div>
                                    <div className='d-flex flex-wrap pt-3'>

                                        {Array.isArray(frames) && frames.length > 0 && (
                                            frames?.map((prop, index) => {
                                                // let name = prop?.applet?.name ? prop?.applet?.name : prop.name
                                                return (

                                                    <Responsive className={'px-1 mb-1'} key={index} width={this.props.width} media={{ xs: "12", sm: '6', md: '4', lg: "3", xl: "3" }}>

                                                        <button className='flexc py-2 w-100 bb-gray br-10 px-2' onClick={() => this.changeFrame(prop)} style={{ backgroundColor: "#fff", boxShadow: '0px 0px 10px #10101010' }}>

                                                            <div className='mrd-3 flexcc' style={{ position: 'relative', }} >
                                                                <img className="br-50" style={{ width: 40, height: 40, objectFit: 'cover', border: '2px solid #ffffff90' }} src={imageAddress(prop?.image, 'applet', 'thumb')} alt='' />
                                                            </div>

                                                            <div className='d-flex flex-column' style={{ textAlign: 'start' }}>
                                                                <p className='font-size-14 main-c2 text-bold'>{checkTranslation(prop?.name)}</p>
                                                                {prop.appletHub &&
                                                                    <p className='font-size-12 main-c9'>{checkTranslation(prop.applet?.name)}</p>
                                                                }
                                                            </div>
                                                        </button>
                                                    </Responsive>
                                                )

                                            })
                                        )}
                                    </div>
                                </>)}


                                <div className='px-1 mt-4'>
                                    <p className='font-size-15 weight-600' >{translate('Recently used')}</p>
                                </div>

                                <div className='flexcc flex-column mt-3'>
                                    <img src='/assets/icons/useful/file-backup.png' height={60} alt='' />
                                    <p className='text-small text-semibold text-center mt-1'>{translate("Found nothing")}</p>
                                    <p className='text-smaller text-semibold text-center mt-1'>{translate("You have not used any file recently")}</p>

                                </div>


                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}